//bottom-chart.js
import React from 'react'

const BottomChart = () => {
	return <div>BottomChart</div>
}

export default BottomChart
